import {Sync} from '@client/sync'
import {Project} from '@extensions/project'
import {Sticker} from '@extensions/sticker/sticker'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'

export const createBoard = (boardName: string, project: Hub): Hub => {
  const board = Project.addBoard(boardName, project, false)
  const {addToBoard, getByName} = Sticker
  const box = Sync.getCurrentSandbox()
  const userSticker = getByName(box, 'User')
  userSticker && addToBoard(board, userSticker)
  const deadlineSticker = getByName(box, 'Deadline')
  deadlineSticker && addToBoard(board, deadlineSticker)

  return board
}

export const getOrCreateBoard = (title: string, project: Hub): Hub => {
  const boards = Project.listBoards(project)

  const boardName = title || Lang.msg.importFromFile.otherTasks

  const board = boards.find(p => p.title === boardName)

  return board || createBoard(boardName, project)
}
